import { IconButton, Table, TableBody, TableHeader, TableRow, TableRowColumn } from "material-ui";
import React from "react";
import { FormattedMessage } from "react-intl";
import images from "../../config/images";
import { NavigationArrowDropDown } from 'material-ui/svg-icons';

const tdStyle = {
  padding: "0px",
  borderRight: "1px solid #b8b8b8",
  textAlign: "center",
  whiteSpace: "pre-wrap",
  overflow: "hidden",
  padding: '0 10px',
  color: "#6B7c93"
};

const flexCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const navigationArrowStyle = {
  fill: '#fff',
  cursor: 'pointer',
  width: '36px',
  height: '36px'
}

export const TableRowContent = ({ label, sortAddressBook }) => {
  return (
    <div style={flexCenter}>
      <FormattedMessage id={"emailAddressBook." + label} />
      <NavigationArrowDropDown onClick={() => sortAddressBook(label)} style={navigationArrowStyle} />
    </div>
  )
}

class EmailAddressBookTable extends React.Component {
  constructor(props) {
    super(props);
  }

  getRoles = (role) => {
    let roles = role.split(',');
    if (roles.length > 1) {
      return <span>
        <FormattedMessage id={"emailAddressBook.host"} /><br />
        <FormattedMessage id={"emailAddressBook.participant"} />
      </span>
    } else if (role) {
      return <FormattedMessage id={"emailAddressBook." + role.toLowerCase().trim()} />
    } else {
      return "";
    }
  }

  render() {
    return (
      <div className="table-wrapper">
        <Table
          selectable={false}
          selectedColor="black"
          height="72vh"
          fixedHeader={true}
          style={{ border: "1px solid #b8b8b8", minWidth: '612px' }}
        >
          <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false}>

            <TableRow
              style={{
                border: "1px solid #b8b8b8",
                backgroundColor: "#6B7c93",
                color: "#fff",
              }}
            >
              <TableRowColumn align="center" style={{ ...tdStyle, color: '#fff', verticalAlign: 'center' }}>
                <TableRowContent label="name" sortAddressBook={this.props.sortAddress} />
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: '#fff' }}>
                <TableRowContent label="email" sortAddressBook={this.props.sortAddress} />
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: '#fff' }}>
                <TableRowContent label="role" sortAddressBook={this.props.sortAddress} />
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: '#fff' }}>
              {<FormattedMessage id="emailAddressBook.group" />}
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: '#fff' }}>
                {<FormattedMessage id="emailAddressBook.edit" />}
              </TableRowColumn>
            </TableRow>
          </TableHeader>
          <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>

            {(this.props.emailAddressBook.length === 0 || this.props.emailAddressBook.every(a => !a.isVisible)) && (
              <TableRow
                selected={false}
                className="light-row"
                style={{
                  backgroundColor: "#f2f3f6",
                  borderBottom: "1px solid #b8b8b8",
                }}
              >
                <TableRowColumn colSpan={5} style={tdStyle}>
                  <p style={{ color: "#979797" }}>
                    {this.props.emailAddressBook.length === 0
                      ? <FormattedMessage id="emailAddressBook.noUsers" />
                      : <FormattedMessage id="emailAddressBook.noResultFound" />
                    }
                  </p>
                </TableRowColumn>
              </TableRow>
            )}

            {this.props.emailAddressBook.map((address, index) => {
              if (address.isVisible) {
                return (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn style={tdStyle}>{address.name}</TableRowColumn>
                    <TableRowColumn style={tdStyle}>
                      {address.email_address}
                    </TableRowColumn>
                    <TableRowColumn style={tdStyle}>{this.getRoles(address.role)}</TableRowColumn>
                    <TableRowColumn style={tdStyle}>
                      {address.group_names.toString().replace(/,(?=[^\s])/g, ", ") || "-"}
                    </TableRowColumn>
                    <TableRowColumn style={tdStyle}>
                      <IconButton
                        onClick={(e) => this.props.editAddress(address)}
                        iconStyle={{ height: "23px" }}
                        touchRippleColor="red"
                      >
                        <img src={images.editIcon} />
                      </IconButton>
                    </TableRowColumn>
                  </TableRow>
                );
              }
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default EmailAddressBookTable;



// WEBPACK FOOTER //
// src/components/EmailAddressBook/EmailAddressBookTable.js